import { Col, Row } from "antd";
import { useEffect, useRef, useState } from "react";
import SponsorOrphanCard from "../../../../biblio/Cards/SponsorOrphanCard";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import { scroll } from "../../../../components/utils/utils";
import SponsorDonation from "./SponsorDonation";
import SponsorResult from "./SponsorResult";
import { addOrUpdateItem, removeItem } from "./utils";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import { getOrphansNeeds } from "../../../../apis/actions/sponsor.actions";

interface PropsAllSponsorOrphans {
  data?: any;
  mobile?: any;
}

const AllSponsorOrphans = ({ data, mobile }: PropsAllSponsorOrphans) => {
  const currentRef = useRef<HTMLDivElement>(null);
  const [items, setItemServices] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch<AppDispatch>();
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);

  const { orphansNeeds, TotalOrphansNeeds, loading } = useSelector(
    (state: RootState) => state?.sponsor
  );
  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };

  const sortedData =
    orphansNeeds &&
    orphansNeeds
      .map((item: any) => item)
      .sort((a: any, b: any) => a.sequence - b.sequence);

  const itemPerPage = 4;

  useEffect(() => {
    dispatch(
      getOrphansNeeds({
        limit: itemPerPage,
        page: currentPage,
        sponsor_id: OtpId,
      })
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, currentPage]);
  if (loading) {
    return (
      <div className="takaful--loading-projects-cases">
        <p className="takaful--no-project-message"> جارٍ التحميل</p>
        <DotsLoader />
      </div>
    );
  }

  return (
    <>
      <SponsorResult items={items} />
      {sortedData && sortedData.length === 0 ? (
        <p className="takaful--no-services">لا توجد أيتام أو أرامل</p>
      ) : (
        <>
          <Row dir="rtl" ref={currentRef} gutter={[16, 16]}>
            {sortedData &&
              sortedData.map((item: any, index: number) => (
                <Col
                  key={(currentPage - 1) * itemPerPage + index}
                  xxl={12}
                  xl={12}
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                >
                  <SponsorOrphanCard
                    removeValue={(item) =>
                      setItemServices(removeItem(item, [...items]))
                    }
                    updateValue={(item) =>
                      setItemServices(addOrUpdateItem(item, [...items]))
                    }
                    data={item}
                    key={index + itemPerPage}
                    defaultItem={
                      items.filter(
                        (el) => el.beneficiary_service_request_id === item.id
                      )[0] ?? null
                    }
                  />
                </Col>
              ))}
          </Row>

          <div className="takaful--pagination-container">
            {sortedData &&
              Math.ceil(TotalOrphansNeeds * itemPerPage) > itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalOrphansNeeds * itemPerPage)}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
          <SponsorDonation items={items} mobile={mobile} />
        </>
      )}
    </>
  );
};

export default AllSponsorOrphans;
